// 国际化标题映射配置
const titleMap = {
  // 菜单
  '首页': 'Home',
  '客服': 'Support',
  '授权': 'Authorize',
  '图库': 'Gallery',
  '选品': 'Product',
  '设计': 'Design',
  '刊登': 'Publish',
  '订单': 'Order',
  '入仓': 'Goods In',
  '数据': 'Data',
  '个人': 'Account',
  'IP隔离': 'IP Isolation',

  '店铺授权': 'Store Authorization',
  '图库管理': 'Gallery Management',
  '定制产品': 'Customized Products',
  '设计师产品': 'Designer Products',
  '本地仓产品': 'Local Warehouse Products',
  '通用数据': 'General Data',
  '订单管理': 'Order Management',
  '订单辅助': 'Order Assistance',
  '物流管理': 'Logistics Management',
  '产品入仓': 'Product Inbound',
  '数据分析': 'Data Analytics',
  '交易统计': 'Transaction Statistics',
  '账户信息': 'Account Information',
  '团队管理': 'Team Management',
  '帮助资讯': 'Help & Support',

  '我的图库': 'My Gallery',
  '收费图库': 'Premium Gallery',
  '共享图库': 'Shared Gallery',
  '出单图库': 'Order Gallery',
  '子账号图库': 'Sub-account Gallery',
  '定制选品': 'Customizable Picks',
  '主题选品': 'Themed Selections',
  '现货选品': 'Ready-to-Ship Picks',
  '我的定制': 'My Customizations',
  '我的主题': 'My Themes',
  '我的现货': 'My Ready-made Items',
  '设计器': 'Designer',
  '批量设计': 'Batch Design',
  '汇出记录': 'Export History',
  '通用模板': 'General Templates',
  '产品模板': 'Product Templates',
  '发布产品': 'List Products',
  '线上产品': 'Live Products',
  '新增产品': 'Add New Product',
  '草稿箱': 'Drafts',
  'Lazada订单': 'Lazada Orders',
  'Shopee订单': 'Shopee Orders',
  'Tiktok订单': 'Tiktok Orders',
  '待关联订单': 'Orders Pending Association',
  '已关联产品': 'Associated Products',
  '已转换产品': 'Converted Products',
  '物流跟踪': 'Shipment Tracking',
  '入仓申请': 'Inbound Request',
  '交易记录': 'Transaction History',
  '店铺交易汇总': 'Store Transaction Summary',
  '订单交易详情': 'Order Transaction Details',
  '设计统计': 'Design Statistics',
  '订单统计': 'Order Statistics',
  '个人信息': 'Profile',
  '购买会员': 'Upgrade to Pro',
  '充值': 'Top Up',
  '提现': 'Withdraw',
  '实名认证': 'Real-name Verification',
  '帮助中心': 'Help Center',
  '反馈问题': 'Submit Feedback',
  '角色管理': 'Role Management',
  '成员管理': 'User Management',
  '公告信息': 'Announcements',

  //tiktok订单 
  // 菜单
  '业务订单': 'Business Orders',
  '售后订单': 'After-sale Orders',
  '全部订单': 'All Orders',
  '未安排': 'Unassigned',
  '待打单': 'Pending Print',
  '待揽收': 'Awaiting Pickup',
  '待发货': 'Awaiting Shipment',
  '已交运': 'Shipped',
  '已取消': 'Canceled',
  '退货到库': 'Return Received',

  // 订单状态
  '待编辑': 'Pending Edit',        
  '待付货款': 'Payment Pending',      
  '已付货款': 'Payment Completed',   
  '排单中': 'Scheduling',            
  '已发货': 'Shipped',               
  '生产中': 'In Production',          
  '审核不通过': 'Review Failed',    
  '退货申请': 'Return Request',

  // 工厂编号
  '跨境仓1': 'Cross-border Warehouse 1',
  '东南亚仓': 'Southeast Asia Warehouse', 
  '菲律宾仓1': 'Philippines Warehouse 1',
  '菲律宾仓2': 'Philippines Warehouse 2',
  '菲律宾退货件仓': 'Philippines Returns Warehouse',
  '菲律宾仓3': 'Philippines Warehouse 3', 
  '菲律宾仓4': 'Philippines Warehouse 4',
  '菲律宾仓5': 'Philippines Warehouse 5',
  '菲律宾仓6': 'Philippines Warehouse 6',
  '菲律宾仓7': 'Philippines Warehouse 7',
  '菲律宾仓8': 'Philippines Warehouse 8',
  '泰国仓1': 'Thailand Warehouse 1',
  '泰国仓2': 'Thailand Warehouse 2', 
  '泰国仓3': 'Thailand Warehouse 3',
  '泰国仓4': 'Thailand Warehouse 4',
  '泰国仓5': 'Thailand Warehouse 5',
  '泰国仓6': 'Thailand Warehouse 6',
  '泰国仓7': 'Thailand Warehouse 7',
  '泰国仓8': 'Thailand Warehouse 8',
  '马来仓1': 'Malaysia Warehouse 1',
  '马来仓2': 'Malaysia Warehouse 2',
  '马来仓3': 'Malaysia Warehouse 3', 
  '印尼仓1': 'Indonesia Warehouse 1',
  '印尼仓2': 'Indonesia Warehouse 2',
  '印尼仓3': 'Indonesia Warehouse 3',
  '印尼仓4': 'Indonesia Warehouse 4',
  '印尼仓5': 'Indonesia Warehouse 5',
  '印尼仓6': 'Indonesia Warehouse 6',
  '新加坡仓1': 'Singapore Warehouse 1',
  '越南仓1': 'Vietnam Warehouse 1',
  '越南仓2': 'Vietnam Warehouse 2',
  '巴西仓1': 'Brazil Warehouse 1',
  '巴西仓2': 'Brazil Warehouse 2',
  '巴西仓3': 'Brazil Warehouse 3',
  '巴西仓4': 'Brazil Warehouse 4', 
  '巴西仓5': 'Brazil Warehouse 5',

  // 发布状态
  '待发布': 'Pending Publish',      
  '已发布': 'Published',           
  '发布中': 'Publishing',           
  '发布失败': 'Publish Failed', 

  // 订单来源类型
  '导入': 'Imported', 
  '同步': 'Synced', 
  '自建': 'Self-created',
  
  // 关联状态  
  '未关联': 'Unlinked',
  '自动关联': 'Auto-linked',
  '手动关联': 'Manually Linked',
  '自建订单': 'Self-created Order',
  
  // 订单处理类型
  '正常安排': 'Normal Arrangement',
  '取消订单': 'Order Cancellation',
  '测评单': 'Review Order',
  '新元素': 'New Element',
  '设置差价包': 'Set Price Difference Package',
  '尺寸修改为3XL': 'Size Modified to 3XL',
  '其他': 'Other',

  //天数
  '1天': '1 Day',
  '1~3天': '1-3 Days', 
  '3~5天': '3-5 Days',
  '5~7天': '5-7 Days',
  '大于7天': 'Over 7 Days',

  // 公告类型
  '新品发布': 'New Products',
  '物流公告': 'Shipping', 
  '网站公告': 'Website',
  '功能更新': 'Updates',

  // 授权状态
  '未授权': 'Unauthorized',
  '已授权': 'Authorized',
  
  // 启用状态  
  '正常': 'Active',
  '禁用': 'Disabled',
};

/**
 * 国际化标题转换方法
 * @param {string} v - 中文标题
 * @param {string} locale - 当前语言环境，默认从Vue实例获取
 * @returns {string} 转换后的标题
 */
export const enTitle = (v, locale = 'zh') => {
  // 如果是中文环境，直接返回原文本
  if (locale === 'zh') {
    return v;
  }
  
  // 英文环境下进行转换
  return titleMap[v] || v;
};

export default enTitle;